<p>
  signout works!
</p>
